import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import CurrentUser from '../CurrentUser';

const AuthorizedRoute = ({ component: Component, render, allowedRoles, ...rest }) => (
  <CurrentUser
    render={currentUser => (
      <Route
        {...rest}
        render={props =>
          currentUser
            && currentUser.role
            && allowedRoles.includes(currentUser.role.name) ? (
              render ?
                render(props)
                : <Component {...props} />
            ) : (
              <Redirect to="/unauthorized" state={{ from: props.location }} />
            )
        }
      />
    )}
  />
);

AuthorizedRoute.defaultProps = {
  allowedRoles: []
}

export default AuthorizedRoute;



// WEBPACK FOOTER //
// ./src/components/routes/AuthorizedRoute.js